import { useEffect, useRef, useState } from 'react';
import { useStore } from '@store/appStore';
import { useI18n } from '@i18n/useI18n';
import db from '@utils/db';
import DefaultTemplate from '@templates/DefaultTemplate';
import { Wrapper } from '@components/GridCards/Common.styled';
import Profile from '@components/Profile';
import { useAuthentication } from '@providers/AuthProvider';
import CounselorList from './CounselorList';
import { GridWrapper } from '@components/GridCards/Common.styled';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import moment from 'moment';

export const Counselor = () => {
  const {
    callNameSetting,
    setCounselorStudent,
    setPinnedCounselorStudents,
    counselorStudent,
    filterDate,
    settings,
    client,
    note,
    pinnedCounselorStudents,
    caseworkerId,
    whoIsLoggedIn,
    caseworkers,
    setCaseworkers,
    alertInfo,
    user,
    systemSettings
  } = useStore();
  const [total, setTotal] = useState(null);
  const [day, setDay] = useState(null);
  const [studentsLoading, setStudentsLoading] = useState(false);
  const [noteInfo, setNoteInfo] = useState(null);
  const [studentLoading, setStudentLoading] = useState(null);
  const [totalAbsence, setTotalAbsence] = useState(null);
  const [registrationsData, setRegistrationsData] = useState(null);
  const [dayData, setDayData] = useState(null);
  const dataLoading = useRef(false)

  const i18n = useI18n();
  const { getType } = useAuthentication();

  useEffect(() => {
    if (counselorStudent === null) {

      if (pinnedCounselorStudents === null && whoIsLoggedIn !== null) getCaseworkerData();
      clearData();
    }
    window.scrollTo(0, 0);
  }, [counselorStudent, filterDate, whoIsLoggedIn]);

  useEffect(() => {
    if (caseworkerId && whoIsLoggedIn && !alertInfo.open) {
      getCaseworkerData()
      clearData();
    }
  }, [caseworkerId, whoIsLoggedIn, alertInfo])


  const clearData = () => {
    setTotal(null);
    setDay(null);
  };


  useEffect(() => {
    if (note && note === true && counselorStudent && counselorStudent.username) {
      setNoteInfo({ notePresent: noteInfo && noteInfo.notePresent === true, noteUnreadCount: 0 });
    }
  }, [note]);

  function getCaseworkerData() {
    if(settings.DEMO === "true" || settings.DEMO === true)
    {
      getCaseworkerDataDemo()
    }
    else if(client.client_id === 17)
    {
      getCaseworkerDataSCNO()
    }
    else
    {
      getCaseworkerDataOther()
    }
  }

  async function getCaseworkerDataOther() {    
    if (dataLoading.current) return
    dataLoading.current = true
    let timezone = systemSettings.find((s) => s.APP_Setting_ID === 7);

    let caseworkerData = await db.GetStudentsInfo(timezone.value)
    caseworkerData = caseworkerData?.filter(s => s.active)
    
    if (caseworkerData) {
      if (pinnedCounselorStudents !== null && pinnedCounselorStudents.length === 0) setStudentsLoading(true);
      let today = moment()      
      let caseworkers = ["Alle"]
      setCaseworkers(caseworkers)
      let tempArray = []
      caseworkerData.map(a => {
        tempArray.push({ student_username: a.username })        
      })

      let t = await db.GetCaseWorker_Students(JSON.stringify(tempArray), client.UserName, getType(), filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE)      
      setPinnedCounselorStudents(t);
    }    

    dataLoading.current = false
    setStudentsLoading(false);
  }


  async function getCaseworkerDataSCNO() {
    if (dataLoading.current) return
    dataLoading.current = true

    let caseworkerData = await db.getDniCaseWorkerClients(caseworkerId)
    if (caseworkerData) {
      if (pinnedCounselorStudents !== null && pinnedCounselorStudents.length === 0) setStudentsLoading(true);
      let today = moment()
      let temp = caseworkerData.filter(a => a.Unilogin !== '').filter(a => {
        let slutDato = a.henvisningSlutDato !== "" ? moment(a.henvisningSlutDato) : moment()
        let startDato = a.henvisningStartDato !== "" ? moment(a.henvisningStartDato) : moment()

        return startDato.isSameOrBefore(today, day) && slutDato.isSameOrAfter(today, day)
      })
      let caseworkers = ["Alle"]

      temp.forEach(element => {
        if (!caseworkers.includes(element.KontaktPerson.trim()) && element.KontaktPerson.trim().length > 0) caseworkers.push(element.KontaktPerson.trim())
      });

      if (((user.name).trim()) !== "" && !caseworkers.includes((user.name).trim())) caseworkers.push((user.name).trim())
      setCaseworkers(caseworkers)
      let tempArray = []
      let x = []
      temp.map(a => {
        tempArray.push({ student_username: a.KursistNummer, KontaktPerson: a.KontaktPerson })
        x.push({ username: a.KursistNummer, KontaktPerson: a.KontaktPerson })
      })

      let t = await db.GetCaseWorker_Students(JSON.stringify(tempArray), client.UserName, getType(), filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE)
      mergeByProperty(t, x, "username")
      setPinnedCounselorStudents(t);
    }

    dataLoading.current = false
    setStudentsLoading(false);
  }

  async function getCaseworkerDataDemo() {
    if (dataLoading.current) return
    dataLoading.current = true
    let caseworkers = ["Alle", "Demo teacher", "Demo caseworker"]
    if (((whoIsLoggedIn.firstname + " " + whoIsLoggedIn.lastname).trim()) !== "" && !caseworkers.includes((whoIsLoggedIn.firstname + " " + whoIsLoggedIn.lastname).trim())) caseworkers.push((whoIsLoggedIn.firstname + " " + whoIsLoggedIn.lastname).trim())
    setCaseworkers(caseworkers)

    let t = await db.GetCaseWorker_Students(JSON.stringify([{ "student_username": "118796" }, { "student_username": "58828" }, { "student_username": "119745" }, { "student_username": "AAJ" }, { "student_username": "136295" }, { "student_username": "54268" }, { "student_username": "AAF" }]), client.UserName, getType(), filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE)
    let x = [{ "username": "118796", KontaktPerson: "Demo caseworker" }, { "username": "58828", KontaktPerson: "Demo teacher" }, { "username": "119745", KontaktPerson: "Demo teacher" }, { "username": "AAJ", KontaktPerson: "Demo caseworker" }, { "username": "136295", KontaktPerson: "Demo teacher" }, { "username": "54268", KontaktPerson: "Demo teacher" }, { "username": "AAF", KontaktPerson: "Demo caseworker" }]

    mergeByProperty(t, x, "username")

    if (settings.USENOTFULLBLOCKPAUSE) {
      let pauseStudents = await db.GetPause4Students(JSON.stringify(t.map(s => { return { student_id: s.student_id } })), filterDate.from, filterDate.to);
      for (let i = 0; i < pauseStudents.length; i++) {
        const s = pauseStudents[i];
        let student = t.find(st => st.student_id === s.student_id)
        if (student) {
          student.absenceduration = student.absenceduration - s.pause_absence_length;
          student.duration = student.duration - s.pause_length
          student.merit = true
        }
      }
    }

    setPinnedCounselorStudents(t);
    dataLoading.current = false
    setStudentsLoading(false);
  }

  const mergeByProperty = (target, source, prop) => {
    source.forEach(sourceElement => {
      let targetElement = target.find(targetElement => {
        return sourceElement[prop] === targetElement[prop];
      })
      targetElement ? Object.assign(targetElement, sourceElement) : null;
    })
  }

  const selectStudent = (username, displayname, id) => {
    setStudentLoading(true);
    let userId = username;
    db.GetNoteCounts4Student(id, client.UserName, getType()).then((notePresent) => {
      setCounselorStudent({
        username: username,
        name: displayname,
        sisId: id,
        notePresent: notePresent && notePresent.length > 0 && notePresent[0].notePresent === true,
        noteUnreadCount: notePresent && notePresent.length > 0 ? notePresent[0].noteUnreadCount : 0,
      });
      setStudentLoading(false);
    });
    db.Student_Stat_GetTotalPercentage(userId, filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE).then((totalData) => {
      const totalabsence = totalData ? totalData[0] : null;
      if (settings.USENOTFULLBLOCKPAUSE) {
        db.GetPause4Students(JSON.stringify([{ student_id: id }]), filterDate.from, filterDate.to).then(r => {
          if (r.length > 0) {
            //@ts-ignore
            totalabsence.secondabsence = totalabsence.secondabsence - r[0].pause_absence_length
            //@ts-ignore
            totalabsence.secondcount = totalabsence.secondcount - r[0].pause_length
            //@ts-ignore
            totalabsence.merit = true
          }
          setTotalAbsence(totalabsence);
        })
      }
      else {
        setTotalAbsence(totalabsence);
      }
    });
    db.Student_Stat_GetTotalPercentageDay(userId, filterDate.from, filterDate.to, null, null, settings.USEMERIT, settings.USEPAUSE).then((dayData) => {
      setDayData(dayData);
    });
  };

  return (
    <Wrapper>
      {
        counselorStudent !== null || studentLoading === true ? (
          studentLoading === true ? (
            <GridWrapper setMinHeight={true}>
              <RainbowLoader />
            </GridWrapper>
          ) : (
            <Profile
              id={counselorStudent.username}
              sisId={counselorStudent.sisId}
              user_id={counselorStudent.sisId}
              firstname={counselorStudent.name}
              lastname={''}
              lastLogin={'client.LASTLOGIN'}
              day={dayData}
              total={totalAbsence}
              isAdmin={true}
              noteCount={counselorStudent.noteUnreadCount}
              notePresent={counselorStudent.notePresent}
              counselor={true}
            />
          )
        ) : <CounselorList selectStudent={selectStudent} title={i18n.t(callNameSetting + "-s")} content={pinnedCounselorStudents} extraButtons={true} caseworkers={caseworkers} />
      }
    </Wrapper>
  );
};

export default Counselor;
